// @vue/component
export default {
  name: 'EffectFilters',

  props: {
    effectList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filteredEffect: '',
      isSelectDisabled: false,
    };
  },

  created() {

  },
  methods: {
    selectChange() {
      this.$emit('changeEffect', this.filteredEffect);
    },
  },

};
